<template>
  <v-container
    id="user-training-task-view"
    fluid
    tag="section"
  >
    <cumulus-edit-dialog
      ref="editTasks"
      v-model="dialogEditTask"
      icon="$edit"
      :title="$t('task_informations')"
      @save="updateTask"
      @escape="closeDialogEditTask"
    >
      <template v-slot:editform>
        <edit-user-training-task
          :user-training-task="editedItem"
        />
      </template>
    </cumulus-edit-dialog>
    <material-card
      icon="$user_training"
      icon-small
      color="accent"
      :title="page_title"
    >
      <template v-slot:title2>
        <div class="text-h5">
          <tooltip-btn
            icon="$back"
            tooltip="planning"
            @click="back"
          />
        </div>
      </template>
      <v-card-title>
        <v-row class="ma-0">
          <v-btn
            v-if="false"
            v-shortkey.once="['f2']"
            color="primary"
            :disabled="!editor"
            class="mb-2"
            @shortkey="newItem()"
            @click="newItem()"
          >
            {{ $t('new_item',{ item: $t('task') }) }}
          </v-btn>
          <v-btn
            color="primary"
            class="ma-2"
            @click="getReport({ type: 'user-training-report', user_training_id: user_training_id})"
          >
            {{ $t('download_user_training_report') }}
          </v-btn>
          <v-switch
            v-model="show_closed"
            class="ml-2"
            :label="$t('show_closed')"
          />
          <v-spacer v-if="!$vuetify.breakpoint.mdAndDown" />
          <data-selector
            v-if="trainings_list_enabled"
            v-model="user_training_id"
            field-name="training"
            source-type="user-trainings"
            hide-details
            class="mx-2"
          />
          <v-text-field
            v-model="search"
            append-icon="$search"
            class="ml-auto"
            hide-details
            :label="$t('search_records')"
            single-line
          />
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="computed_headers"
          :items="filtered_items"
          :loading="loading"
          :loading-text="$t('loading')"
          :search="search"
          :footer-props="footerProps"
          :item-class="rowClasses"
          show-expand
          :single-expand="singleExpand"
          :expanded.sync="expanded"
        >
          <template v-slot:expanded-item="{ headers, item }">
            <td
              :colspan="headers.length"
              class="ma-3 pa-3"
            >
              <v-row v-if="item.success">
                <v-col>{{ $t('fields.success_date') }}: {{ item.success_date | dateFormat }}</v-col>
              </v-row>
              <v-row class="pb-4">
                <v-col
                  v-for="(flight, i) in item.flights"
                  :key="i"
                  cols="12"
                  md="6"
                  lg="3"
                >
                  <v-card
                    class="mx-auto"
                    min-height="250"
                    :color="flightCardClasses(flight)"
                  >
                    <v-card-text class="pa-0" style="height: 200px;">
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title
                            v-if="flight.pivot.rating > 1"
                            class="green--text"
                          >
                            {{ $t('flight_success') }}
                          </v-list-item-title>
                          <v-list-item-title
                            v-if="flight.pivot.rating == 1"
                            class="red--text"
                          >
                            {{ $t('unsuccess_task_flight') }}
                          </v-list-item-title>
                          <v-list-item-title>
                            <v-list-item dense class="pa-0 ma-0">
                              <v-list-item-title>
                                {{ $t('fields.plane') }}: {{ flight.plane.reg_num }} - {{ flight.plane.model }}
                              </v-list-item-title>
                              <v-list-item-icon>
                                <tooltip-btn
                                  v-if="!item.success && (!flight.pivot.success || instructor)"
                                  color="delete"
                                  icon="$close"
                                  tooltip="tooltip_delete"
                                  custom-class="justify-end"
                                  @click="clickRemoveFlight(item, flight)"
                                />
                              </v-list-item-icon>
                            </v-list-item>
                          </v-list-item-title>
                          <v-list-item-title style="display: flex">
                            <span v-if="flight.instructor != null"> {{ $t('fields.starting_instructor') }}: {{ flight.instructor.name }} </span>
                            <span v-else> {{ $t('fields.instructor') }}: {{ flight.pic.name }} </span>
                          </v-list-item-title>
                          <v-list-item-subtitle> {{ flight.date | dateFormat }} -> {{ flight.takeoff_time | timeFormat }} - {{ flight.landing_time | timeFormat }} </v-list-item-subtitle>
                          <v-list-item-subtitle
                            v-if="flight.pivot.success || flight.pivot.comment"
                            class="text-wrap"
                          >
                            <a
                              v-if="!flight.pivot.success"
                              @click="editFlightComment(flight)"
                            >
                              {{ flight.pivot.comment }}
                            </a>
                            <span v-else>
                              {{ flight.pivot.comment }}
                            </span>
                          </v-list-item-subtitle>
                          <v-textarea
                            v-if="!flight.pivot.success && !flight.pivot.comment"
                            v-model="flight.pivot.comment_edit"
                            append-outer-icon="mdi-content-save"
                            :label="$t('fields.comment')"
                            rows="9"
                            outlined
                            class="mt-1"
                            @click:append-outer="saveFlightComment(item, flight)"
                          />
                        </v-list-item-content>
                      </v-list-item>
                    </v-card-text>
                    <v-card-actions>
                      <v-rating
                        v-if="flight.pivot.comment"
                        v-model="flight.pivot.rating"
                        :readonly="flight.pivot.success === 1 || !isFlightInstructor(flight)"
                        class="pr-2"
                        hover
                        dense
                        length="5"
                        size="20"
                      />
                      <v-btn
                        v-if="flight.pivot.comment && !flight.pivot.success && ((flight.sic_id == student_id && isFlightInstructor(flight)) || (!flight.sic_id && profile.has_role.instructor))"
                        :disabled="!flight.pivot.rating"
                        color="success"
                        small
                        @click="clickSuccessFlight(item, flight)"
                      >
                        {{ $t('i_certify') }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
              <user-training-flight-selector
                v-if="item.training_task.count>0 && item.open && (profile.organization.settings.training_student_edit_on || instructor)"
                :user-training-task="item"
              />
            </td>
          </template>

          <template #item.takeoff_count="{item}">
            <div v-if="item.training_task.count > 0">
              {{ item.training_task.count }} / <span class="blue--text">{{ item.flights.reduce((acc, item) => acc + item.landing, 0) }}</span> / <span class="green--text">{{ item.flights.filter(f => f.pivot.success && f.pivot.rating > 1).reduce((acc, item) => acc + item.landing, 0) }}</span>
            </div>
            <div v-if="item.training_task.count === 0">
              {{ $t('theoretical_training') }}
            </div>
          </template>

          <template #item.actions="{item}">
            <tooltip-btn
              v-if="item.open && !item.success && item.training_task.count <= item.flights.filter(f => f.pivot.success && f.pivot.rating > 1).reduce((acc, item) => acc + item.landing, 0) && instructor"
              color="blue"
              icon="$success"
              tooltip="tooltip_success_training_task"
              @click="clickSuccessTask(item)"
            />
            <tooltip-btn
              v-if="item.open && item.training_task.count === 0 && instructor"
              color="edit"
              icon="$edit"
              tooltip="tooltip_edit"
              @click="clickEdit(item)"
            />
            <tooltip-btn
              v-if="item.open && instructor"
              color="black"
              icon="$lock_open"
              tooltip="tooltip_close_training_task"
              @click="clickCloseTask(item)"
            />
            <tooltip-btn
              v-if="!item.open && instructor"
              color="black"
              icon="$lock"
              tooltip="tooltip_open_training_task"
              @click="clickOpenTask(item)"
            />
            <training-task-informations
              :description="item.training_task.description"
            />
          </template>
        </v-data-table>
      </v-card-text>
    </material-card>
  </v-container>
</template>

<script>
  // Utilities
  import { get, call, sync } from 'vuex-pathify'
  import EditUserTrainingTask from '@/layouts/default/edit/UserTrainingTask'
  import UserTrainingFlightSelector from '@/layouts/default/infos/UserTrainingFlightSelector'
  import { format } from 'date-fns'
  import moment from 'moment'
  import TrainingTaskInformations from '@/layouts/default/infos/TrainingTaskInfo.vue'

  export default {
    name: 'Airports',
    components: {
      TrainingTaskInformations,
      UserTrainingFlightSelector,
      EditUserTrainingTask,
    },
    data () {
      return {
        items: [],
        // table
        footerProps: {
          itemsPerPageOptions: [10, 20, 25, 50, 100],
        },
        timer: null,
        student_id: null,
        user_training_id: null,
        student_name: '',
        show_closed: false,
        dialogEditTask: false,
        editedItem: {},
        expanded: [],
        singleExpand: true,
        commentEdit: true,
        trainings_list_enabled: false,
      }
    },
    computed: {
      loading: get('app/loading'),
      profile: get('auth/profile'),
      search: sync('userTrainingTask/search'),
      datas: get('datasource/datas'),
      table_headers () {
        return [
          {
            text: this.$t('fields.idx'),
            align: 'start',
            sortable: false,
            value: 'training_task.idx',
          },
          {
            text: this.$t('fields.name'),
            align: 'start',
            sortable: false,
            value: 'training_task.name',
          },
          {
            text: this.$t('fields.status'),
            sortable: false,
            value: 'takeoff_count',
          },
          {
            value: 'actions',
            sortable: false,
            align: 'right',
          },
        ]
      },
      actions () {
        return [
          // { color: 'info', icon: '$info' },
          // { color: 'delete', icon: '$delete', tooltip: 'tooltip_delete', func: this.clickDelete, disable: !this.editor },
          // { color: 'edit', icon: '$edit', tooltip: 'tooltip_edit', func: this.clickEdit, disable: !this.editor },
        ]
      },
      page_title () { return this.$t('planning') + ' - ' + this.student_name },
      editor () { return this.profile.can['training-edit-instructor'] },
      instructor () { return this.profile.has_role.instructor },
      computed_headers () { return this.table_headers.filter(h => h.hide_small !== this.$vuetify.breakpoint.mdAndDown) },
      filtered_items () { return this.items.filter(i => i.open || this.show_closed) },
    },
    watch: {
      user_training_id: {
        handler () {
          this.load()
        },
        deep: true,
      },
    },
    mounted () {
      this.student_id = this.$route.params.user_id ? parseInt(this.$route.params.user_id) : this.profile.user_id
      this.user_training_id = this.$route.params.id ? parseInt(this.$route.params.id) : this.profile.trainings[0].id
      if (this.$route.params.id == null) {
        this.trainings_list_enabled = true
      }
      this.getName()
      // this.load()
    },
    methods: {
      getReport: call('action/getReport'),
      getList: call('userTrainingTask/list'),
      update: call('userTrainingTask/update'),
      insert: call('userTrainingTask/insert'),
      remove: call('userTrainingTask/delete'),
      openTask: call('userTrainingTask/open'),
      closeTask: call('userTrainingTask/close'),
      successTask: call('userTrainingTask/success'),
      fetchDatasource: call('datasource/fetchDatasource'),
      userTrainingRemoveFlight: call('userTrainingTask/userTrainingRemoveFlight'),
      userTrainingCommentFlight: call('userTrainingTask/userTrainingCommentFlight'),
      userTrainingSuccessFlight: call('userTrainingTask/userTrainingSuccessFlight'),
      async load () {
        try {
          await this.getList({
            show_closed: this.show_closed,
            user_id: this.student_id,
            user_training_id: this.user_training_id,
          }).then(response => {
            this.items = response
          }).catch(e => {
            console.log(e)
          })
        } catch (e) {
        }
      },
      edit (id) {
        this.$router.push(`/training/edit/${id}`).catch(() => {})
      },
      clickDelete (item) {
        console.log(this.items.indexOf(item))
        this.remove({ id: item.id }).then(response => {
          this.items.splice(this.items.indexOf(item), 1)
        })
        // alert(id)
        // this.$router.push(`/training/edit/${id}`).catch(() => {})
      },
      newItem () {
        this.editedItem = {
          user_id: this.student_id,
        }
        this.dialogEditTask = true
      },
      clickEdit (item) {
        item.success_date = moment(item.success_date).format('yyyy-MM-DD')
        this.editedItem = item
        this.dialogEditTask = true
      },
      updateTask () {
        this.update(this.editedItem).then(response => {
          // this.items.push(response)
          this.closeDialogEditTask()
        })
      },
      closeDialogEditTask () {
        this.dialogEditTask = false
      },
      getName () {
        this.fetchDatasource({ sourceType: 'users' }).then(response => {
          response = response.filter(f => f.id === this.student_id)
          this.student_name = response[0].name
        })
      },
      clickCloseTask (item) {
        this.closeTask(item).then(response => {
          item.open = false
        })
      },
      clickOpenTask (item) {
        this.openTask(item).then(response => {
          item.open = true
          item.success = false
          // item.success_date = null
        })
      },
      clickSuccessTask (item) {
        this.successTask(item).then(response => {
          item.success = true
          item.success_date = item.success_date ?? format(new Date(), 'yyyy-MM-dd')
          item.comment = item.comment ?? 'Végrehajtva'
          item.open = false
          if (this.items.indexOf(item) < this.items.length - 1) {
            this.clickOpenTask(this.items[this.items.indexOf(item) + 1])
          }
        })
      },
      clickRemoveFlight (item, flight) {
        this.userTrainingRemoveFlight({ id: item.id, flight_id: flight.id }).then(response => {
          item.flights.splice(item.flights.indexOf(flight), 1)
        })
      },
      editFlightComment (flight) {
        flight.pivot.comment_edit = flight.pivot.comment
        flight.pivot.comment = null
      },
      saveFlightComment (item, flight) {
        if (flight.pivot.comment_edit) {
          this.userTrainingCommentFlight({ id: item.id, flight_id: flight.id, comment: flight.pivot.comment_edit }).then(response => {
            flight.pivot.comment = flight.pivot.comment_edit
          })
        }
      },
      clickSuccessFlight (item, flight) {
        /* if (flight.pivot.comment === '') {
          flight.pivot.comment = 'Rendben végrehajtva'
        } */
        this.userTrainingSuccessFlight({ id: item.id, flight_id: flight.id, rating: flight.pivot.rating }).then(response => {
          flight.pivot.success = true
        })
      },
      rowClasses (item) {
        if (item.success) {
          return 'green lighten-5'
        } else if (item.open) {
          return 'blue lighten-5'
        } else {
          return 'red lighten-5'
        }
      },
      isFlightInstructor (flight) {
        return (flight.pic.id === this.profile.user_id || flight.instructor_id === this.profile.user_id)
      },
      flightCardClasses (flight) {
        if (flight.pivot.rating === 1) {
          return 'red lighten-5'
        } else if (flight.pivot.success) {
          return 'green lighten-5'
        } else if (flight.pivot.comment) {
          return 'blue lighten-5'
        } else {
          return ''
        }
      },
      back () {
        this.$router.push('/training/planning/').catch(() => {})
      },
    },
  }
</script>

<style lang="sass">
.v-textarea textarea
  font-size: small
  line-height: normal !important
</style>
